var map = {
	"./banner1.jpeg": "6c00e",
	"./banner2.jpeg": "cb16",
	"./banner3.jpeg": "c391",
	"./button-bg-rules-payout.png": "9f07",
	"./effect-ranking-1.gif": "f28a",
	"./latest-result-banner-bg-1.webp": "6e29",
	"./latest-result-banner-bg-2.webp": "5bbb",
	"./latest-result-banner-bg-3.webp": "e7ac",
	"./latest-result-banner-bg-4.webp": "9065",
	"./lotto-list-item-bg-light-special-active.png": "4b38",
	"./lotto-list-item-bg-light.png": "6842",
	"./round-bg-close-light.png": "c9bd",
	"./round-bg-light-active.png": "b8ba",
	"./yeekee1.webp": "f58f",
	"./yeekee2.webp": "356a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "debd";